import React, { useState, useEffect, useRef } from "react";
import {
  Flex,
  Button,
  Text,
  Group,
  Box,
  Stack,
  SimpleGrid,
  Badge,
  ThemeIcon,
  UnstyledButton,
  Divider,
} from "@mantine/core";
import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shallow } from "zustand/shallow";

import useAppStore from "./report-recipe-runner-store";
import entityIcon from "@util/entityIcon";
import { SnapshotQueryVisualizer } from "@components/ReportRecipe";

export default function ReportSnapshotList({ onSelect, selectedId }) {
  const [loading, setLoading] = useState(true);
  const { recipeInfo, savedRecipe } = useAppStore(
    (state) => ({
      recipeInfo: state.recipe_info,
      savedRecipe: state.saved_recipe,
    }),
    shallow
  );

  function generateRequest() {
    return {
      saved_report_recipe_id: savedRecipe?.id,
      report_recipe_id: !savedRecipe ? recipeInfo.id : null,
    };
  }

  const { failureReason: error, data: snapshots } = useQuery({
    queryKey: ["snapshots"],
    queryFn: async () =>
      axios
        .post(`/retrieve-report-snapshots/`, generateRequest())
        .then(({ data }) => {
          setLoading(false);
          return data.response.map((m, i) => ({
            ...m,
          }));
        })
        .catch((err) => {
          setLoading(false);
          return err;
        }),
  });

  if (!snapshots) return null;

  return (
    <div>
      {snapshots.length === 0 && <Text size="sm">No snapshots yet.</Text>}
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
        {snapshots.map((snapshot, index) => (
          <SnapshotCard
            key={snapshot.id}
            snapshot={snapshot}
            selectedId={selectedId}
            onSelect={onSelect}
            showVisualizer={true}
          />
        ))}
      </SimpleGrid>
    </div>
  );
}

export const SnapshotCard = ({
  snapshot,
  selectedId,
  onSelect,
  showVisualizer = false,
}) => {
  const isSelected = selectedId === snapshot.id;
  const hasQueryVisualizerData =
    snapshot?.query_visualizer_data?.data !== undefined;

  return (
    <UnstyledButton
      onClick={() => onSelect(selectedId === snapshot.id ? null : snapshot)}
      style={{
        width: "100%",
      }}
    >
      <Box
        key={snapshot.id}
        withBorder
        padding="xs"
        radius="md"
        style={{
          border: `1px solid ${
            isSelected
              ? "var(--mantine-color-teal-3)"
              : "var(--mantine-color-gray-3)"
          }`,
          borderRadius: "var(--mantine-radius-md)",
          backgroundColor: isSelected ? "var(--mantine-color-teal-0)" : "#fff",
          transition: "all 0.2s ease",
        }}
      >
        <Group gap="sm" wrap="nowrap" style={{ alignItems: "stretch" }}>
          <Box
            style={{
              background: isSelected
                ? "var(--mantine-color-teal-6)"
                : "var(--mantine-color-gray-2)",
              borderRadius:
                "var(--mantine-radius-md) 0 0 var(--mantine-radius-md)",
              // height: "95px",
              flexShrink: 0,
              flexGrow: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "var(--mantine-spacing-xs)",
              width: "60px",
              alignSelf: "stretch",
            }}
          >
            <ThemeIcon
              radius="xl"
              variant={isSelected ? "filled" : "light"}
              size="xl"
              color={isSelected ? "teal" : "teal"}
            >
              {entityIcon.snapshot(20)}
            </ThemeIcon>
          </Box>
          <div>
            <Stack
              gap={1}
              style={{ flexGrow: 1, padding: "var(--mantine-spacing-xs)" }}
            >
              <Text fw={600} size="sm" c="dark.5" lineClamp={1}>
                {snapshot.title}
              </Text>
              <Text size="xs" style={{ maxWidth: "90%" }} lineClamp={1}>
                {snapshot.description || "No description provided"}
              </Text>
              {snapshot.created_at && (
                <Text c="dimmed" size="xs">
                  {new Date(snapshot.created_at).toLocaleString()}
                </Text>
              )}
            </Stack>
            {/* {hasQueryVisualizerData && isSelected && (
              <>
                <Divider />
                <Box pb="md">
                  <SnapshotQueryVisualizer
                    data={snapshot.query_visualizer_data}
                  />
                </Box>
              </>
            )} */}
            {showVisualizer &&
              snapshot.query_visualizer_data &&
              snapshot.query_visualizer_data.display_components &&
              snapshot.query_visualizer_data.display_components.length > 0 && (
                <Box
                  style={{
                    padding:
                      "0 var(--mantine-spacing-xs) var(--mantine-spacing-xs) var(--mantine-spacing-xs)",
                  }}
                >
                  <SnapshotQueryVisualizer
                    mini
                    data={snapshot.query_visualizer_data}
                  />
                </Box>
              )}
          </div>
          {/* <Button
            size="xs"
            color={selectedId === snapshot.id ? "green" : "blue"}
            variant={selectedId === snapshot.id ? "filled" : "light"}
            onClick={() => onSelect(snapshot)}
            style={{
              transition: "all 0.2s ease",
            }}
          >
            View
          </Button> */}
        </Group>
      </Box>
    </UnstyledButton>
  );
};
